import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { queryClient } from '@shared/api';
import { Toaster } from '@ui';

/** Global providers composed at the root (ARCHITECTURE §9). */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <OpenFeatureProvider>
        {children}
        <Toaster />
      </OpenFeatureProvider>
    </QueryClientProvider>
  );
}
